import { BoardColumns } from '../board-table/boardColumns';

export const kJobColumns = {
  plate: { title: '车牌号', flex: 1.8 },
  name: { title: '施工项目', flex: 2.4 },
  technician: { title: '施工员', flex: 1.3 },
  team: { title: '班组', flex: 1.5 },
  startedAt: { title: '开始施工', flex: 1.4 },
  elapsed: { title: '施工耗时', flex: 1.3 },
  status: { title: '状态', flex: 1.1 },
} satisfies BoardColumns;
